import type { UseFetchOptions } from '#app';

export const useApiUploadFile = async (
  url: string,
  formData: FormData,
  api: 'api1' | 'api2' = 'api1'
) => {
  const config = useRuntimeConfig();

  const baseURL = config.public.apiBaseURL;
  const authToken = useCookie<string | null>('iqa-token');

  const jsonUser = JSON.parse(localStorage.getItem("iqa-auth") || "{}");
  const idUsuario = jsonUser.user?.idUsuario ?? "";
  const tenant = jsonUser.selectedTenant?.code;
  const { $i18n } = useNuxtApp();

  swal_loading();

  try {
    const response = await fetch(`${baseURL}${url}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${authToken.value}`,
        'x-tenant': tenant,
        'Accept-Language': $i18n?.locale.value || 'en',
        ...(idUsuario ? { 'x-identity': idUsuario } : {}),
        // NO Content-Type
      },
      body: formData,
    });

    const result = await response.json();

    swal_close();

    if (!response.ok) {
      return { data: null, error: result };
    }

    return { data: result, error: null };

  } catch (error) {
    swal_close();
    return { data: null, error };
  }
};
